<!-- MODAL observacionesModal -->
<div mdbModal #observacionesNoProcesadaModal="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
    role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <form>
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title w-100 text-left" id="myModalLabel">
                        Confirmar cancelación proceso
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="hide()">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <h5 class="modal-title w-100 text-left" id="myModalLabel">
                        ¿Desea cancelar proceso de los documentos seleccionados?
                    </h5>
                </div>
                <form autocomplete="off" [formGroup]="formData">
                    <div class="modal-body">
                        <div class="row mt-3">
                            <div class="col">
                                <div class="md-form">
                                    <input value="" type="text" id="observaciones" class="form-control"
                                        placeholder="Observaciones" required #observaciones
                                        formControlName="observaciones" />
                                    <label for="observaciones">Observaciones</label>
                                    <div *ngIf="
                                    formData.get('observaciones').invalid &&
                                        (formData.get('observaciones').dirty ||
                                        formData.get('observaciones').touched)
                                        ">
                                        <mdb-error *ngIf="formData.get('observaciones').hasError('required')">Ingrese
                                            observaciones
                                        </mdb-error>
                                        <mdb-error *ngIf="formData.get('observaciones').hasError('maxlength')">Máximo
                                            300
                                            caracteres
                                        </mdb-error>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="modal-footer justify-content-between">
                    <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
                        (click)="hide()" mdbWavesEffect>
                        Cerrar
                    </button>
                    <button type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
                        (click)="agregarObservacion()">
                        Enviar
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>